import { getPriorityDropdowns } from "../priority/priority";
import { LIST_ELEMENTS_FOR_DROPDOWNS } from "../routes/queries";
import { LIST_LIFE_DOMAINS } from "../life_domain/routes";
import { FormFieldComponentProps } from "../components/new_form/form_fields/FormFieldComponent";
import { getSession } from "../helper";

export function getNewNextActionFormFields(): FormFieldComponentProps[] {
  return [
    {
      type: "text",
      required: true,
      placeholder: "Name",
      key: "name",
      label: "Name",
    },
    {
      type: "hardcoded",
      key: "type",
      value: 5,
    },
    {
      type: "hardcoded_dropdown",
      required: true,
      label: "Priority",
      options: getPriorityDropdowns(),
      key: "priority",
    },
    {
      type: "int_text",
      required: false,
      placeholder: "Time Estimate",
      key: "minuteEstimate",
      label: "Time Estimate (minutes)",
    },
    {
      type: "checkbox",
      label: "Top Item of Day",
      key: "topItemOfDay",
    },
    {
      type: "query_dropdown",
      required: false,
      label: "Parent Project",
      noSelectionLabel: "No Parent Project",
      key: "parentElementId",
      apiCall: LIST_ELEMENTS_FOR_DROPDOWNS,
      apiVariables: {
        session: getSession(),
        types: [4],
      },
    },
    {
      type: "query_dropdown",
      required: false,
      label: "Life Domain",
      noSelectionLabel: "No Life Domain",
      key: "lifeDomainId",
      apiCall: {
        documentNode: LIST_LIFE_DOMAINS,
        key: "listLifeDomains",
      },
      apiVariables: {
        session: getSession(),
      },
    },
    {
      type: "multiple_selection_query_dropdown",
      required: false,
      label: "Blocked By",
      apiCall: LIST_ELEMENTS_FOR_DROPDOWNS,
      apiVariables: {
        session: getSession(),
        types: [1, 2, 3, 4, 5],
      },
      itemName: "Blocked By",
      key: "blockedByIds",
    },
    {
      type: "multiple_selection_query_dropdown",
      required: false,
      label: "Blocks",
      apiCall: LIST_ELEMENTS_FOR_DROPDOWNS,
      apiVariables: {
        session: getSession(),
        types: [1, 2, 3, 4, 5],
      },
      itemName: "Blocks",
      key: "blocksIds",
    },
  ];
}
